
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.52.935a.487.487 0 01.529.105l5.809 4.564c.19.188.19.497 0 .686l-5.81 4.542a.482.482 0 01-.528.106.477.477 0 01-.29-.449V7.77C3.016 7.77.3 9.521.713 15.102-1.918 6.173 3.134 4.155 9.229 4.155V1.383c.001-.196.109-.373.29-.448z"}})])
          )
        }
      }
    